import { Discount } from "@happy-legal/graphql-types";
import { createContext, ReactNode } from "react";
import { MUTATION_UPDATE_DISCOUNT } from "../gql/mutations";
import { discountReducer, TDiscountAction } from "../reducer";
import { createProvider, IObjectContextType } from "./ProviderFactory";

export const DiscountContext = createContext<
  IObjectContextType<Discount[], TDiscountAction>
>(undefined!);
// TODO: https://www.rivoltafilippo.com/typing-react-context-to-avoid-an-undefined-default-value

DiscountContext.displayName = "Discount Context";

export const discountInitState = [];

const DiscountProvider = ({ children }: { children: ReactNode }) =>
  createProvider(
    DiscountContext,
    discountReducer,
    discountInitState,
    children,
    MUTATION_UPDATE_DISCOUNT
  );

export default DiscountProvider;
